import { isEmpty, size } from 'lodash';
import React, { useEffect, useState } from 'react';

import { close_meeting_detail, filter_talent_finder } from '../../../assets/img';
import {
  CRITICAL_POSITION_FILTERS,
  INCUMBENT_DETAIL_FILTERS,
  POSITION_DETAIL_FILTERS,
  POSITION_FILTER_TITLE,
  POSITION_FINDER_FILTER_LABELS_COLLAPSE,
  POSITION_FINDER_FILTER_OPTIONS,
  POSITION_FINDER_FILTERS,
  SELECT_ALL_LABEL,
  SPUR_DETAIL_FILTERS,
} from '../../../utils/constants';
import styles from './position-filter-finder.module.scss';
import data from './data.json';
import DropdownTreeSelectCustom from '../../../components/DropdownTreeSelectCustom/DropdownTreeSelectCustom';
import { filterCheckedItems } from '../../../utils/helper';

let tempFilter = {
  business: [],
  sector: [],
  opu: [],
  division: [],
  department: [],
  job_grade: [],
  skg: [],
  job_family: [],
  sub_job_family: [],
  function: [],
  spur_name: [],
  position_label: [],
  salary_grade: [],
  years_to_retire: [],
  years_in_position: [],
  work_location: [],
};

let filterTabActive = [];
let preTalentFilterOptions = {};

const FilterFinder = (props) => {
  const {
    filterOptions,
    setFilterOptions,
    setFilterFinderData,
    filterFinderData,
    setIsFilter,
    keySearch,
    setKeyword,
    setPage,
    showFilter,
    // setDebouncedInputValue,
    // debouncedSearchValue,
    prevFilterOptions,
  } = props;
  const [talentFilterOptions, setTalentFilterOptions] = useState({});
  const [currentFilterActive, setCurrentFilterActive] = useState(null);
  const [showFilters, setShowFilters] = useState({
    POSITION_DETAILS: false,
    SPUR: false,
    CRITICAL_POSITION_STATUS: false,
    INCUMBENT_DETAILS: false,
  });
  const [clearFilterName, setClearFilterName] = useState(null);

  const cloneState = (state) => {
    return JSON.parse(JSON.stringify(state));
  };

  const getFilterApplied = () => {
    let tempData = {};
    Object.keys(filterFinderData).forEach((key) => {
      if (!isEmpty(filterFinderData[key]) && filterFinderData[key].filter((i) => i.checked)) {
        tempData[key] = filterFinderData[key];
      }
    });
    return tempData;
  };

  const getFilterLabel = (value) => {
    let tempLabel = [];
    POSITION_FINDER_FILTERS.forEach((item) => {
      if (value === item.value) {
        tempLabel = item.label;
      }
    });
    return tempLabel;
  };

  const getAllKeys = (tree) => {
    let result = [];
    tree.forEach((item) => {
      let childKeys = [];
      if (item?.children) {
        childKeys = getAllKeys(item.children);
      }
      result.push(...[{ label: item?.label, checked: item?.checked }, ...childKeys]);
    });

    return result;
  };

  const returnTempNestedData = (data, filterName, isChecked) => {
    if (isEmpty(data[filterName])) return [];

    return data[filterName].map((item) => {
      if (item?.children) {
        return {
          ...item,
          checked: isChecked,
          children: item?.children.map((c) => {
            if (c?.children) {
              return {
                ...item,
                checked: isChecked,
                children: c?.children.map((i) => ({ ...i, checked: isChecked })),
              };
            } else {
              return {
                ...c,
                checked: isChecked,
              };
            }
          }),
        };
      } else {
        return {
          ...item,
          checked: isChecked,
        };
      }
    });
  };

  useEffect(() => {
    if (!isEmpty(filterOptions)) {
      setTalentFilterOptions({
        ...{
          years_to_retire: data.years_to_retire,
          years_in_position: data.years_in_position,
        },
        ...filterOptions,
      });
      preTalentFilterOptions = {
        ...{
          years_to_retire: data.years_to_retire,
          years_in_position: data.years_in_position,
        },
        ...filterOptions,
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterOptions]);

  const handleApplyFilter = (key, filterApplied) => {
    const tempData = !isEmpty(filterApplied) ? filterApplied : talentFilterOptions[key];

    tempFilter[key] = tempData;
    setTalentFilterOptions({ ...talentFilterOptions, key: tempData });

    if (!filterTabActive.includes(key)) {
      filterTabActive.push(key);
    }

    const dataToPost = getDataToPost();
    setKeyword(keySearch);
    setFilterFinderData(dataToPost);
    setFilterOptions((prev) => {
      return {
        ...prev,
        [key]: tempData,
      };
    });
    preTalentFilterOptions = cloneState(talentFilterOptions);
    setIsFilter(true);
    setPage(1);
  };

  const getDataToPost = () => {
    const business = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.BUSINESS]);
    const sector = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.SECTOR]);
    const opu = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.OPU]);
    const division = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.DIVISION]);
    const department = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.DEPARTMENT]);
    const job_grade = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.JOB_GRADE]);
    const skg = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.SKG]);
    const job_family = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.JOB_FAMILY]);
    const sub_job_family = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.SUB_JOB_FAMILY]);
    const job_function = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.JOB_FUNCTION]);
    const spur_name = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.SPUR_NAME]);
    const position_label = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.CRITICAL_POSITION_CATEGORY]);
    const salary_grade = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.SALARY_GRADE]);
    const years_to_retire = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.YEARS_TO_RETIRE]);
    const years_in_position = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.YEARS_IN_POSITION]);
    const work_location = filterCheckedItems(tempFilter[POSITION_FINDER_FILTER_OPTIONS.WORK_LOCATION]);

    return {
      business,
      sector,
      opu,
      division,
      department,
      job_grade,
      skg,
      job_family,
      sub_job_family,
      function: job_function,
      spur_name,
      position_label,
      salary_grade,
      years_to_retire,
      years_in_position,
      work_location,
    };
  };

  const onBlur = (item, key) => {
    talentFilterOptions[key] = item;
    setTalentFilterOptions(preTalentFilterOptions);
  };

  const handleClearFilter = () => {
    Object.keys(tempFilter).forEach((key) => {
      tempFilter[key] = [];
    });
    filterTabActive = [];
    setIsFilter(false);
    setFilterFinderData({});
    setTalentFilterOptions({
      ...{
        years_to_retire: data.years_to_retire,
        years_in_position: data.years_in_position,
      },
      ...prevFilterOptions,
    });
    setFilterOptions({
      ...{
        years_to_retire: data.years_to_retire,
        years_in_position: data.years_in_position,
      },
      ...prevFilterOptions,
    });
    setPage(1);
  };

  // Handle reset when leaving page
  useEffect(() => {
    return () => {
      setKeyword('');
      handleClearFilter();
    };
  }, []);

  const dropDownGenerator = (item) => {
    return Object.keys(talentFilterOptions).map((key, index) => {
      if (item.value === key) {
        return (
          <DropdownTreeSelectCustom
            key={`${key}.${index}`}
            filterTabActive={filterTabActive}
            label={item.label}
            placeholder={item.label}
            data={talentFilterOptions[key]}
            filterName={key}
            setCurrentFilterActive={setCurrentFilterActive}
            currentFilterActive={currentFilterActive}
            onApply={handleApplyFilter}
            onBlur={() => {
              onBlur(talentFilterOptions[key], key);
            }}
            clearFilterName={clearFilterName}
            setClearFilterName={setClearFilterName}
          />
        );
      }
      return null;
    });
  };

  const toggleFilter = (filterName) => {
    setShowFilters((prevFilters) => ({
      ...prevFilters,
      [filterName]: !prevFilters[filterName],
    }));
  };

  useEffect(() => {
    setShowFilters({
      POSITION_DETAILS: showFilter,
      SPUR: showFilter,
      CRITICAL_POSITION_STATUS: showFilter,
      INCUMBENT_DETAILS: showFilter,
    });
  }, [showFilter]);

  const handleClearFilterItem = (key) => {
    const tempData = returnTempNestedData(talentFilterOptions, key, false);
    tempFilter[key] = [];
    filterTabActive = filterTabActive.filter((i) => i !== key);
    setTalentFilterOptions({ ...talentFilterOptions, key: tempData });
    setFilterOptions((prev) => {
      return {
        ...prev,
        [key]: tempData,
      };
    });

    // handle re-call api to get data table
    setKeyword(keySearch);
    const dataToPost = getDataToPost();
    setFilterFinderData(dataToPost);
    setIsFilter(true);
    setPage(1);
  };

  const flattenNestedObject = (data) => {
    const result = [];

    const flatten = (node) => {
      result.push({ ...node, children: undefined }); // Add the current node without children
      if (node.children && Array.isArray(node.children)) {
        node.children.forEach(flatten); // Recursively flatten children
      }
    };

    if (Array.isArray(data)) {
      data.forEach(flatten); // Handle arrays at the root level
    } else {
      flatten(data); // Handle single root objects
    }

    return result;
  };

  const handleGetFilterAppliedItem = (data, key) => {
    if (isEmpty(data)) return '';

    const tempArr = flattenNestedObject(tempFilter[key]);
    const isCheckUnCheckedItem = tempArr.some((i) => !i?.checked);
    const isCollapseLabel = POSITION_FINDER_FILTER_LABELS_COLLAPSE.includes(key);

    if (!isCheckUnCheckedItem) return 'All';
    if (isCollapseLabel) return handleGetFilterAppliedItemCollapse(data);
    return data.map((item, index) => {
      if (item.checked && item.label !== SELECT_ALL_LABEL) {
        if (item?.children && !isEmpty(item?.children)) {
          return `${item?.label}: ${item?.children
            .filter((c) => c.checked)
            .map((i, indx) => {
              return indx === item?.children?.length - 1 ? i.label : `${i.label}`;
            })
            .join(', ')}, `;
        } else {
          return index === data.length - 1 ? item.label : `${item.label}, `;
        }
      }
    });
  };

  const handleGetFilterAppliedItemCollapse = (data) => {
    let totalCount = 0;
    let firstLabel = '';

    data.forEach(({ checked, label, children }) => {
      if (!checked || label === SELECT_ALL_LABEL) return;

      const checkedChildren = children?.filter((child) => child.checked) || [];
      if (checkedChildren.length > 0) {
        if (!firstLabel) {
          firstLabel = `${label} : ${checkedChildren[0].label}`;
        }
        totalCount += checkedChildren.length;
      } else {
        if (!firstLabel) {
          firstLabel = label;
        }
        totalCount += 1;
      }
    });

    return `${firstLabel}${totalCount > 1 ? `.. +${totalCount - 1} more` : ''}`;
  };

  const isShowFilterApplied = () => {
    let isCheck = false;
    if (size(filterTabActive) > 0) {
      Object.keys(getFilterApplied()).forEach((key) => {
        const allKeys = getAllKeys(getFilterApplied()[key]);
        const tempCheckedItem = allKeys.some((i) => i?.checked);
        if (tempCheckedItem) {
          return (isCheck = true);
        }
      });
    }
    return isCheck;
  };

  return (
    <div className={styles.filter_section}>
      {isShowFilterApplied() && (
        <div className={styles.filter_section_top}>
          <div className={styles.filter_applied}>
            <div className={styles.filter_applied_title}>Filter Applied:</div>
            <div className={styles.filter_applied_list}>
              {Object.keys(getFilterApplied()).map((key) => {
                const allKeys = getAllKeys(getFilterApplied()[key]);
                const tempCheckedItem = allKeys.some((i) => i?.checked);
                if (tempCheckedItem) {
                  return (
                    <div key={key} className={styles.filter_applied_item}>
                      {`${getFilterLabel(key)}: `}
                      {handleGetFilterAppliedItem(getFilterApplied()[key], key)}{' '}
                      <img
                        className={styles.close_icon_label}
                        src={close_meeting_detail}
                        alt=""
                        onClick={() => {
                          handleClearFilterItem(key);
                          setClearFilterName(key);
                        }}
                      />
                    </div>
                  );
                } else {
                  return '';
                }
              })}
            </div>
          </div>
          <button
            className={'clear_filter_button'}
            onClick={() => {
              handleClearFilter();
              setClearFilterName('ALL');
            }}
            style={{ margin: 0, width: '120px' }}
          >
            Clear Filters
          </button>
        </div>
      )}
      <div className={`filter_section row p-4 ${styles.container}`}>
        <div className={styles.filter_list_wrapper}>
          <div className={styles.filter_title} onKeyDown={() => {}} onClick={() => toggleFilter('POSITION_DETAILS')}>
            {POSITION_FILTER_TITLE.POSITION_DETAILS}
            <img src={filter_talent_finder} alt="" />
          </div>
          {!isEmpty(talentFilterOptions) && showFilters.POSITION_DETAILS && POSITION_DETAIL_FILTERS.map((item) => dropDownGenerator(item))}
        </div>
        <div className={styles.filter_list_wrapper}>
          <div className={styles.filter_title} onKeyDown={() => {}} onClick={() => toggleFilter('SPUR')}>
            {POSITION_FILTER_TITLE.SPUR}
            <img src={filter_talent_finder} alt="" />
          </div>
          {!isEmpty(talentFilterOptions) && showFilters.SPUR && SPUR_DETAIL_FILTERS.map((item) => dropDownGenerator(item))}
        </div>
        <div className={styles.filter_list_wrapper}>
          <div className={styles.filter_title} onKeyDown={() => {}} onClick={() => toggleFilter('CRITICAL_POSITION_STATUS')}>
            {POSITION_FILTER_TITLE.CRITICAL_POSITION_STATUS}
            <img src={filter_talent_finder} alt="" />
          </div>
          {!isEmpty(talentFilterOptions) && showFilters.CRITICAL_POSITION_STATUS && CRITICAL_POSITION_FILTERS.map((item) => dropDownGenerator(item))}
        </div>
        <div className={styles.filter_list_wrapper} style={{ gridColumn: 2 }}>
          <div className={styles.filter_title} onKeyDown={() => {}} onClick={() => toggleFilter('INCUMBENT_DETAILS')}>
            {POSITION_FILTER_TITLE.INCUMBENT_DETAILS}
            <img src={filter_talent_finder} alt="" />
          </div>
          {!isEmpty(talentFilterOptions) && showFilters.INCUMBENT_DETAILS && INCUMBENT_DETAIL_FILTERS.map((item) => dropDownGenerator(item))}
        </div>
      </div>
    </div>
  );
};

export default FilterFinder;
